import { CourseLectureId } from './course-lecture-interface'
import { CourseQuizId } from './course-quiz-interface'

export enum CourseLectureAssignmentStatusEnum {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
  NotSubmitted = 'not_submitted',
}

export interface CourseMenuLectureInterface {
  id: CourseLectureId
  name: string
  available: boolean
  completed: boolean
  assignment: {
    mandatory: boolean
    status: CourseLectureAssignmentStatusEnum | null
  } | null
}

export interface CourseQuizInterface {
  id: CourseQuizId
  available: boolean
  completed: boolean
}

export interface CourseMenuModuleInterface {
  lectures: CourseMenuLectureInterface[]
  salesPage?: string
  name: string
  quiz: CourseQuizInterface | null
  available: boolean
  isCompleted: boolean
  shouldShowQuiz: boolean
}
